module.exports = __webpack_public_path__ + "img/task-icon.ad9df396.svg";